import dayjs from 'dayjs';
import { Button } from 'flowbite-react';
import { useEffect, useState } from 'react';
import { UserAvailabilityInput } from 'types';
interface Props {
	scheduledTimeSlot: UserAvailabilityInput;
	counsellingLink: string;
}

const CounsellingConfirmationPage = ({ scheduledTimeSlot, counsellingLink }: Props) => {
	const [isButtonDisabled, setIsButtonDisabled] = useState(true);

	useEffect(() => {
		let intervalId: NodeJS.Timeout; // Declare intervalId with a type

		const checkTime = () => {
			const currentTime = dayjs();
			const slotStartTime = dayjs(scheduledTimeSlot?.startTime);
			const isBefore = currentTime.isBefore(slotStartTime);
			setIsButtonDisabled(isBefore); // Enable button if time has passed

			if (!isBefore) {
				clearInterval(intervalId); // Stop the interval if time has passed
			}
		};

		checkTime();
		intervalId = setInterval(checkTime, 1000); // Check every second

		return () => clearInterval(intervalId); // Cleanup interval on component unmount
	}, [scheduledTimeSlot]);

	return (
		<>
			<div className="flex flex-col mx-auto rounded-[8px] justify-center items-center py-4">
				<div className="max-w-md w-full flex flex-col items-center text-center space-y-6">
					<div className="max-w-[48px] max-h-[48px] mx-auto mt-[64px]">
						<img src="/assets/assessmentcompleted/circle.svg" className="w-full h-full" />
					</div>
					<div className="space-y-2 text-[#544D4F] text-[16px] leading-[24px] font-[500]">
						Counselling session has been scheduled
						<br />
						for{' '}
						<span className="text-[#3470E4] text-[16px] font-[600] leading-[24px]">
							{dayjs(scheduledTimeSlot?.startTime)?.format('DD MMM, hh:mm a')}
						</span>
						<br />
						Calendar invite has been sent to your email.
					</div>
					<div className="flex gap-4 w-full max-w-[230px] items-center justify-center">
						<Button
							type="button"
							color="purplePlaced"
							size="lg"
							className="w-full"
							onClick={() => {
								window.open(counsellingLink);
							}}
							disabled={isButtonDisabled}
						>
							Join Counselling
						</Button>
					</div>
				</div>
			</div>
		</>
	);
};

export default CounsellingConfirmationPage;
